import { render } from "./Alert.vue?vue&type=template&id=b88e9bcc"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/messages/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b88e9bcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b88e9bcc', __exports__)) {
    api.reload('b88e9bcc', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=b88e9bcc", () => {
    api.rerender('b88e9bcc', render)
  })

}


export default __exports__